import { render, staticRenderFns } from "./VehicleDeviationReport.vue?vue&type=template&id=085dc48b"
import script from "./VehicleDeviationReport.vue?vue&type=script&lang=js"
export * from "./VehicleDeviationReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports